import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import Main from './Main';
import 'helpers/initFA';

const container = document.getElementById('main');
const app = (
  <React.StrictMode>
    <Main>
      <App />
    </Main>
  </React.StrictMode>
);

// Use hydrate for react-snap pre-rendered pages, createRoot for dev
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
